const riot = require('riot');

riot.tag2('modal-calendar', '<div class="w472 bg-white border pt18 pb24 px16 rounded-8" ref="modal" tabindex="0" onkeydown="{handleEnterKey}"> <div class="f fm fbw mb18"> <div class="fs16 bold">期限設定</div><i class="icon-close fs24 text-label_dark_medium cursor-pointer" onclick="{close}"></i> </div> <div class="f fm fbw mb5"><i class="icon-arrow-left fs16 cursor-pointer" onclick="{onPrev}"></i> <div class="fs13 lh15 bold" if="{base}">{base.format(\'YYYY年 MM月\')}</div><i class="icon-arrow-right fs16 cursor-pointer mrn3" onclick="{onNext}"></i> </div> <div class="row mb15" onmouseleave="{onMouseleaveRemove}"> <div class="px8 pt8 pb4 text-center border-bottom border-separator_opacity mb8" each="{week, index in weeks}" riot-style="width: {100/7}%"> <div class="f fh text-center fs10 text-{getTextColor(index)}">{week}</div> </div> <div class="relative f fh h44 text-center cursor-pointer p8 {getDateClass(date)}" each="{date in dates}" riot-style="width: {100/7}%" onclick="{onSelectPeriod}" onmouseenter="{onMouseEnterDate}"> <div class="lh15 fs13 mb4">{date.date()}</div> <div class="absolute b6 fs10 word-break-keep" if="{isHoliday(date.toDate())}">{getHolidayLabel(date.toDate())}</div> <div class="absolute b2 w28 h2 bg-deep rounded-full" if="{date.isSame(Date.now(),\'date\')}"></div> </div> </div> <div class="mb24"> <div class="fs13 bold mb12">終了日設定</div> <div class="row mb12"> <button class="h24 border border-label_dark_disabled fs11 px6 rounded-6 hover-trigger hover-border-background_dark_primary mr8" each="{date in endDates}" onclick="{onSelectEndDate}"> <div class="fs11">{date.label}</div> </button> </div> <div class="row f fm"> <button class="h24 border border-label_dark_disabled fs11 px6 rounded-6 hover-trigger hover-border-background_dark_primary mr8" each="{date in businessDays}" onclick="{onSelectBusinessDays}"> <div class="fs11">{date.label}</div> </button><i class="icon-help cursor-pointer fs20 tooltip" aria-label="営業日とは、土日および祝日を除いた平日のことを指します。" data-tooltip-position="top"></i> </div> </div> <div class="f fh"> <div class="button dark w113 h40 mr16" onclick="{onPeriodClear}">クリア</div> <div class="button primary h40 w113" onclick="{onSave}">保存</div> </div> </div>', 'modal-calendar,[data-is="modal-calendar"]{ background-color: rgba(28, 34, 54, 0.9); }', 'class="f fh" spat-animation="push"', function(opts) {

    this.weeks = ["月", "火", "水", "木", "金", "土", "日"];

    this.endDates = [
      { label: "今日", days: 0 },
      { label: "明日", days: 1 },
      { label: "3日後", days: 3 },
      { label: "1週間後", days: 7 },
    ];

    this.businessDays = [
      { label: "1営業日後", days: 1 },
      { label: "3営業日後", days: 3 },
      { label: "5営業日後", days: 5 },
    ];

    this.on('mount', () => {
      requestAnimationFrame(() => {
        this.refs.modal.focus();
      });

      this.startAt = this.opts.note.data.start_at || dayjs().endOf('date').valueOf();

      this.endAt = this.opts.note.data.end_at;

      this.setup();
    });

    this.setup = (base) => {
      this.base = base || dayjs();

      const start = this.base.startOf('month');

      const end = this.base.endOf('month');

      this.dates = Array(end.date()).fill(0).map((v, i) => {

        return start.add(i, 'day').endOf('date');
      });

      let prev_month_date_num = ((start.day()+7)-1)%7;
      Array(prev_month_date_num).fill(0).forEach((v, i) => {
        this.dates.unshift(start.add(-(i+1), 'day').endOf('date'));
      });

      let next_month_date_num = 7 * 6 - this.dates.length;
      Array(next_month_date_num).fill(0).forEach((v, i) => {
        this.dates.push(end.add(i+1, 'day').endOf('date'));
      });
      this.update();
    };

    this.isToday = (date) => {
      return this.today.format('YYYY-MM-DD') === date.format('YYYY-MM-DD');
    };

    this.onPrev = () => {
      this.setup(this.base.add(-1, 'month'));
    };

    this.onNext = () => {
      this.setup(this.base.add(1, 'month'));
    };

    this.onSave = async () => {

      if(this.startAt && !this.endAt) {
        this.endAt = this.startAt;
      }

      await this.opts.note.updatePeriod({start_at: this.startAt, end_at: this.endAt});
      this.close();
      app.utils.openToast('setPeriod');
    };

    this.onSelectEndDate = (e) => {
      let {days} = e.item.date;

      this.startAt = dayjs().endOf('date').valueOf();

      this.endAt = dayjs().add(days, "d").endOf('date').valueOf();
    };

    this.onSelectBusinessDays = (e) => {
      let { days } = e.item.date;

      let current_date = dayjs().endOf('date');
      let days_added = 0;

      while (days_added < days) {
        current_date = current_date.add(1, 'day');

        const is_weekend = current_date.day() === 0 || current_date.day() === 6;
        const is_holiday = this.isHoliday(current_date.toDate());

        if (!is_weekend && !is_holiday) {
          days_added++;
        }
      }

      this.endAt = current_date.valueOf();

      this.startAt = dayjs().endOf('date').valueOf();
      this.update();
    };

    this.getTextColor = (i) => {
      const SATURDAY = 5;
      const SUNDAY = 6;
      if (i === SUNDAY) {
        return 'alert_primary';
      }
      else if (i === SATURDAY) {
        return 'deep';
      }
      else {
        return 'label_dark_medium';
      }
    };

    this.onSelectPeriod = (e) => {

      let time = e.item.date.valueOf();

      if(!this.startAt) {
        this.startAt = time;
        return;
      }

      if(this.endAt) {

        if(e.item.date.isBefore(this.endAt,"date")) {
          this.startAt = time;
          this.endAt = null;
          return ;
        }
      }

      if (e.item.date.isAfter(this.startAt)) {
        this.endAt = time;
      }
      else {
        this.startAt = time;
      }
    };

    this.isBetween = (date) => {

      return date.isAfter(this.startAt,"date") && date.isBefore(this.endAt,"date");
    };

    this.getDateClass = (date) => {

      let is_saturday = date.day() === 6;

      let is_sunday = date.day() === 0;

      let is_holiday = this.isHoliday(date.toDate());

      if(this.startAt){

        if(date.isSame(this.startAt,"date")){
          return "text-white bg-primary rounded-top-left-4 rounded-bottom-left-4";
        }

        if(this.endAt) {

          if(date.isSame(this.endAt,"date")){
            return "text-white bg-primary rounded-top-right-4 rounded-bottom-right-4";
          }

          if(this.isBetween(date)) {
            return "bg-pale";
          }
        }

        if(this.hoverDate) {

          if(this.hoverDate.isSame(date,"date") || date.isAfter(this.startAt,"date") && this.hoverDate.isAfter(date,"date")) {
            return "bg-pale";
          }
        }
      }

      if(date.isSame(this.base, "month")) {
        if (is_sunday || is_holiday) {
          return "text-alert_primary";
        }
        if (is_saturday) {
          return "text-deep";
        }
        return "text-label_dark_primary";
      }

      else {
        if (is_sunday || is_holiday) {
          return "text-alert_primary_50";
        }
        else if (is_saturday){
          return "text-deep_50";
        }
        return "text-label_dark_disabled";
      }
    };

    this.onMouseEnterDate = (e) => {
      this.hoverDate = e.item.date;
    };

    this.onMouseleaveRemove = () => {
      this.hoverDate = null;
    };

    this.onPeriodClear = async () => {
      this.startAt = null;
      this.endAt = null;

      await this.opts.note.updatePeriod({start_at: this.startAt, end_at: this.endAt});
      this.close();
      app.utils.openToast('clearPeriod');
    };

    this.getHolidayLabel = (date) => {
      let holiday = app.holidayJp.between(date, date)[0];
      if (holiday) {
        return holiday.name;
      }
      return "";
    };

    this.isHoliday = (date) => {
      return app.holidayJp.isHoliday(date);
    };

    this.handleEnterKey = (e) => {
      if(e.key === 'Enter'){
        this.onSave();
      }
    };
});